import { FC, memo } from "react";
import { CenteredLoadingIndicator } from "../components/CenteredLoadingIndicator";

export const PageLoading: FC = memo(() => <CenteredLoadingIndicator />);
